




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ChangelogEntryViewObject, ChangelogCategoryViewObject } from '@/types/apiServerContract';

@Component
export default class ChangelogCategorySelector extends Vue {
	@Prop({ required: true, type: Array }) entries!: ChangelogEntryViewObject[];
	@Prop({ required: true }) exactActive!: ChangelogCategoryViewObject | null;

	children: ChangelogEntryViewObject[] | null = null;
	active: ChangelogCategoryViewObject | null = null;

	isActive(id: string) {
	    return this.active ? this.active.id === id : false;
	}

	isExactActive(id: string) {
	    return this.exactActive ? this.exactActive.id === id : false;
	}

	select(entry: ChangelogEntryViewObject) {
	    this.active = entry.category;
	    this.children = entry.children.length > 0 ? entry.children : null;

	    this.$emit('select', entry.category);
	}

	onSelect(category: ChangelogEntryViewObject) {
	    this.$emit('select', category);
	}
}
